interface IProps {
  readonly title?: string | ((currentPage?: number) => React.ReactNode);
  readonly currentPage?: number;
  readonly style?: React.CSSProperties;
}

export const TableTitleComponent = (props: IProps) => {
  if (!props.title) {
    return null;
  }
  return (
    <div className="table-title" style={props.style}>
      {typeof props.title === 'string'
        ? props.title
        : props.title(props.currentPage)}
    </div>
  );
};
